/* 
 * Export component file to be used on project
*/

import Logo from './Logo.js';
export default Logo;
